import "./styles.scss";

import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import slugify from "slugify";

import { useFaq } from "context/client/faq";

import Button from "components/Button";
import FaqFilters from "../FaqFilters";
import SelectablePill from "components/SelectablePill";
import MostSearched from "../MostSearched";

import useResponsive from "libs/helpers/useResponsive";

import { ReactComponent as ArrowIcon } from "assets/icons/new/forward-arrow.svg";

const mainClass = "faq-tiles";

const FaqTiles = () => {
  const { t } = useTranslation();
  const { max } = useResponsive();

  const { dataSorted, setSelected } = useFaq();

  const [isMostSearchedOpen, setIsMostSearchedOpen] = useState(false);

  useEffect(() => {
    if (!max.sm && isMostSearchedOpen) setIsMostSearchedOpen(false);
  }, [max.sm, isMostSearchedOpen]);

  return (
    <>
      <div className={mainClass}>
        <div className={`${mainClass}__header`}>
          <Button
            onClick={max.sm ? () => setIsMostSearchedOpen(true) : undefined}
          >
            {t("See FAQs")}
          </Button>
        </div>
        <div className={`${mainClass}__body`}>
          <div className={`${mainClass}__filters`}>
            <FaqFilters />
          </div>
          <div className={`${mainClass}__row`}>
            {dataSorted.map((item) => {
              const slug = item.category.slug;
              const title = item.title;
              const category = {
                label: item.category.title,
                color:
                  slug === "payments-and-subscriptions"
                    ? "blue"
                    : slug === "referral-program"
                      ? "green"
                      : "yellow",
              };

              return (
                <div
                  key={slugify(item.content.slice(0, 24), {
                    lower: true,
                    strict: true,
                  })}
                  className={`${mainClass}__item`}
                >
                  <h6>{title}</h6>
                  <div className={`${mainClass}__item-footer`}>
                    <SelectablePill data={category} />
                    <button
                      type="button"
                      onClick={() =>
                        setSelected({
                          title,
                          category,
                          content: item.content,
                        })
                      }
                    >
                      {t("See answer")}
                      <i>
                        <ArrowIcon />
                      </i>
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {max.sm && (
        <MostSearched.Modal
          isOpen={isMostSearchedOpen}
          onClose={() => setIsMostSearchedOpen(false)}
        />
      )}
    </>
  );
};

export default FaqTiles;
